<template>
<div style="height: 700px">
  <div class="title-top-alarm">
    <span v-if="moduletag === 2">【{{ oldPersonRow.elderly_name }}】评估数据</span>
    <span v-else>【{{ oldPersonRow.name }}】评估数据</span>
    <div class="line-title"></div>
  </div>
  <div style="height: 40px;margin: 10px 40px">
    <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
      <span>{{item.name}}</span>
    </div>
  </div>
  <div v-if="indexActive === 0" style="height: calc(100% - 124px);overflow-y: auto">
    <last-time ref="last" :lastObj="evaluateObj" @openEdit="editBtn" @openAdd="addBtn"></last-time>
  </div>
  <div v-if="indexActive === 1" style="height: calc(100% - 124px);overflow-y: auto">
    <div style="height: 100%;margin: 0 30px">
      <el-table :data="elderlyassessment" border highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="daily_activity_score"
          label="自理能力得分"
          min-width="90"
          align="center">
        </el-table-column>
        <el-table-column
          label="基础运动能力得分"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.extra_info.sports_score">{{scope.row.extra_info.sports_score}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="mental_state_score"
          label="精神状态得分"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          label="感知觉与社会参与得分"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.extra_info.society_perception_score">{{scope.row.extra_info.society_perception_score}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="assessor_name"
          label="评估人员"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="assessment_completion_date"
          label="评估人员日期"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="informant_name"
          label="信息提供者"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="evaluation_application_date"
          label="信息提供者日期"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          label="评估地点"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.extra_info.assessor_address">{{scope.row.extra_info.assessor_address}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="评估时间"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column align="center" label="操作" width="90">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="editBtn(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
  <el-dialog :visible.sync="addEditShow" v-if="addEditShow" fullscreen
             :show-close="true" :close-on-click-modal="false" center class="all-open" append-to-body>
    <evaluate-ability v-model="addEditShow" :addEditObj="addEditObj" @updateData="updateData"></evaluate-ability>
  </el-dialog>
</div>
</template>

<script>
import {queryelderlyassessmenthistory} from '../../../api/yanglaoyuan'
import evaluateAbility from '../../evaluateAbility/evaluateAbility'
import lastTime from './lastTime'
export default {
  name: 'evaluateHistory',
  components: {lastTime, evaluateAbility},
  model: {
    prop: 'evaluateShow',
    event: 'change'
  },
  props: {
    evaluateObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      moduletag: 1,
      tabs: [
        {index: 0, name: '最新评估'},
        {index: 1, name: '历史评估'}
      ],
      indexActive: 0,
      oldPersonRow: '',
      elderlyassessment: [],
      addEditObj: {
        oldPersonRow: '',
        row: '',
        isAdd: true
      },
      addEditShow: false
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.oldPersonRow = this.evaluateObj.oldPersonRow
    this.addEditObj.oldPersonRow = this.evaluateObj.oldPersonRow
    // this.getHistoryData()
  },
  methods: {
    selectTab (item) {
      this.indexActive = item.index
      if (this.indexActive === 1) {
        this.getHistoryData()
      }
    },
    getHistoryData () {
      let data = {
        ep_id: this.oldPersonRow.id
      }
      this.elderlyassessment = []
      queryelderlyassessmenthistory(data).then(res => {
        let arr = []
        for (let i = 0; i < res.data.elderlyassessment.length; i++) {
          let obj = this.clone(res.data.elderlyassessment[i])
          if (obj.extra_info && obj.extra_info !== '') {
            obj.extra_info = JSON.parse(res.data.elderlyassessment[i].extra_info)
          }
          arr.push(obj)
        }
        this.elderlyassessment = arr
      })
    },
    addBtn () {
      this.addEditObj.row = ''
      this.addEditObj.isAdd = true
      this.addEditShow = true
    },
    editBtn (row) {
      this.addEditObj.row = row
      this.addEditObj.isAdd = false
      this.addEditShow = true
    },
    updateData () {
      this.getHistoryData()
      if (this.indexActive === 0) {
        this.$refs.last.getInfo()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/evaluateHistory.vue